module.exports = __webpack_public_path__ + "img/dab_flamandzki.f24ec4f0.jpg";